export default __webpack_public_path__ + "static/media/logo_mycynchealth_color.2c5a3187.png";